export default __webpack_public_path__ + "static/media/certificate_1.451bb5d7.jpg";